import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, AccountsService } from '../shared/services';
import { Account } from '../shared/models';

@Component({
  styles: [require('./home.style.scss')],
  template: require('./home.template.pug')
})
export class HomeComponent implements OnInit, AfterViewInit {

  accounts: Account[] = [];
  logoAnimation = 'slideInDown';
  welcomeAnimation = 'slideInUp';

  constructor(
    private _router: Router,
    private _authSvc: AuthService,
    private _accService: AccountsService
  ) { }

  ngOnInit() {
      this.accounts = this._accService.getAccounts();
  }

  ngAfterViewInit() {
    if (this.accounts.length > 0) {
      this._router.navigate(['/accounts']);
    }
  }

  addAccountClicked() {
    this.logoAnimation = 'slideOutUp';
    this.welcomeAnimation = 'slideOutDown';

    setTimeout(() => this._router.navigate(['/accounts']), 1000);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/home/home.component.ts